module.exports = __webpack_public_path__ + "~@/assets/img/code.b769760d.jpg";